import VideoCard from "./VideoCard";
import type { Video } from "@/types/video";

interface VideoGridProps {
  videos: Video[];
  onReset?: () => void;
  emptyText?: string;
}

export default function VideoGrid({
  videos,
  onReset,
  emptyText = "暂无符合条件的视频，您可以调整筛选条件。",
}: VideoGridProps) {
  if (videos.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-movie-2-line text-3xl"></i>
        </span>
        <p className="mt-4 text-base font-medium text-foreground-800">
          {emptyText}
        </p>
        <p className="mt-1 text-sm text-foreground-400">
          试试更换地区、年份或排序方式
        </p>
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
          >
            <i className="ri-refresh-line"></i>
            重置筛选条件
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
      {videos.map((video) => (
        <VideoCard key={video.id} video={video} />
      ))}
    </div>
  );
}